package app.nestbridge.feature.careteam.service

import app.nestbridge.feature.careteam.api.CareTeamApiClient
import app.nestbridge.feature.careteam.model.CareTeam
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = CareTeamService::class)
@Inject
class DefaultCareTeamService(
    private val apiClient: CareTeamApiClient,
) : CareTeamService {

    override suspend fun get(id: String): CareTeam? = apiClient.fetch(id)?.toDomain()

    override suspend fun findAll(): List<CareTeam> = apiClient.fetchAll().map { it.toDomain() }

    override suspend fun findByChildId(childId: String): List<CareTeam> =
        apiClient.fetchByChildId(childId).map { it.toDomain() }

    override suspend fun save(careTeam: CareTeam): CareTeam = apiClient.save(careTeam.toDto()).toDomain()
}
